import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { SignupService } from 'src/app/services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { FacebookService, InitParams, LoginOptions, LoginResponse } from 'ngx-facebook';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { MetaPixelService } from 'src/app/services/metapixel.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as AuthActions from '../../store/shared/auth/auth.actions'
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
declare var $;

@Component({
  selector: 'app-become-a-host',
  templateUrl: './become-a-host.component.html',
  styleUrls: ['./become-a-host.component.css']
})
export class BecomeAHostComponent implements OnInit {
  facebookLoginErrorMessage;
  socialLoginToken;
  passingSignupData = false;
  googleRecapthaSiteKey = "6LfzUlUaAAAAAKKv0UBaepUWBOJKiZ62xqtvqREh";
  counrtyList;

  form = new UntypedFormGroup({
    firstName: new UntypedFormControl('', Validators.required),
    lastName: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', Validators.required),
    country: new UntypedFormControl('', Validators.required),
    howDidYouHear: new UntypedFormControl(''),
    recaptcha: new UntypedFormControl('', Validators.required),
    receiveCheckbox: new UntypedFormControl(true)
  })

  socialUpdateForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
  })

  constructor(
    public signUpService: SignupService,
    private toastr: ToastrService,
    private fb: FacebookService,
    private $gaService: GoogleAnalyticsService,
    private metaPixelService: MetaPixelService,
    private router: ActivatedRoute,
    private route: Router,
    private store: Store<AppState>,
    private gtmService: GoogleTagManagerService
  ) {
    const initParams: InitParams = {
      //appId: '162560842317790',
      //appId: '193130834427739',
      appId: '558848698455833',
      status: true,
      cookie: true,
      xfbml: true,
      version: 'v17.0'
    };

    fb.init(initParams);

    this.signUpService.getAllCountries().subscribe(data => {
      this.counrtyList = data["data"]
    });


    this.signUpService.getUserIPData().subscribe(data => {
      const countryCode = data['country'] === 'GB' ? 'UK' : data['country']; 
      this.form.patchValue({ country: countryCode });
    })
  }
  lang;
  ngOnInit(): void {
    this.router.paramMap.subscribe(params => {
      this.lang = params.get('lang');
    });
    
  }

  keyPressAlphabethic(event) {

    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkInputValidations() {
    var hasError = false

    if (this.form.controls.firstName.status == "INVALID") {
      this.form.controls.firstName.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.lastName.status == "INVALID") {
      this.form.controls.lastName.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.email.status == "INVALID") {
      this.form.controls.email.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.password.status == "INVALID") {
      this.form.controls.password.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.country.status == "INVALID") {
      this.form.controls.country.markAsTouched()
      hasError = true;
    }


    if (this.form.controls.recaptcha.status == "INVALID") {
      this.form.controls.recaptcha.markAsTouched()
      hasError = true;
    }

    return hasError;


  }
  signUp() {
    if (this.checkInputValidations() == false) {

      this.passingSignupData = true; 


      let payload= {
        country_code: this.form.value.country,
        find_us: this.form.value.howDidYouHear,
        is_etsy_user: false,
        email: this.form.value.email.toLowerCase(),
        google: { token: this.form.value.recaptcha, action: 'BECOME_A_HOST' },
        mail_permission: this.form.value.receiveCheckbox,
        name: this.form.value.firstName,
        password: this.form.value.password,
        surname: this.form.value.lastName
      }

      this.signUpService.becomeAHostwithEmail(payload
      ).subscribe(data => {

        if (data["result"]["status"] == 200) {
          localStorage.setItem('token', data["data"]["token"]);
          localStorage.setItem('is_email_verified', data["data"]["user"]["is_email_verified"]);
          localStorage.setItem('userId', data["data"]["user"]["id"]);
          localStorage.setItem('is_phone_verified', data["data"]["user"]["is_phone_verified"]);
          localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]['user']));
          let user: object = data["data"]['user'];
          this.store.dispatch(AuthActions.LoginSuccess({ token: data['data']['token'], user }))
          // //this.metaPixelService.onHostSignUpEvent(data["data"].user.email);
          this.$gaService.event('host_sign_up', 'host_sign_up', data["data"].user.email);
          const gtmTag = {
            event: 'gtmHostSignUp',
            data: {
              email: data['data']['user']['email'],
            }
          }
          this.gtmService.pushTag(gtmTag);
          this.route.navigate(['/','verification'])


        }
        else {
          this.toastr.error(data["result"]["message"], 'Error');
          this.passingSignupData = false;
        }

      })
    }
  }
  loginWithFacebook(): void {

    document.getElementById("facebookLoginStatusModalBtn").click();

    let loginOptions: LoginOptions = {
      scope: 'email'
    }

    this.fb.login(loginOptions)
      .then((response: LoginResponse) => {
        var userData = {
          "access_token": response.authResponse.accessToken,
          "facebook_user_id": response.authResponse.userID,
          "type": 2
        }

        this.signUpService.signUpwithFacebook(userData).subscribe(data => {
          if (data["result"]["status"] == 200) {
            localStorage.setItem('token', data["data"]["token"]);
            localStorage.setItem('is_email_verified', data["data"]["user"]["is_email_verified"]);
            localStorage.setItem('userId', data["data"]["user"]["id"]);
            localStorage.setItem('is_phone_verified', data["data"]["user"]["is_phone_verified"]);
            localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]['user']));
            let user: object = data["data"]['user'];
            this.store.dispatch(AuthActions.LoginSuccess({ token: data['data']['token'], user }))
            // //this.metaPixelService.onHostSignUpEvent(data["data"].user.email);
            this.$gaService.event('host_sign_up', 'host_sign_up', data["data"].user.email);
            const gtmTag = {
              event: 'gtmHostSignUp',
              data: {
                email: data['data']['user']['email'],
              }
            }
            this.gtmService.pushTag(gtmTag);
            document.getElementById('facebookLoginCloseModalBtn').click();
            this.route.navigate(['/','verification'])
          }
          else {
            this.toastr.error(data["result"]["message"], 'Error');
            //this.passingSignupData = false;

            if (data["result"]["status"] == 855) {
              //this.updateSocialLoginProfile(data["data"]["token"])
              document.getElementById('facebookLoginCloseModalBtn').click();
              document.getElementById("socialUpdateModalTriggerBtn").click();
              this.socialLoginToken = data["data"]["token"]
            }
          }
        })

      })
      .catch((error: any) =>{
        this.toastr.error(error.message, 'Error');
      });
  }
  // loginWithGoogle(): void {

  //   this.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then((val: firebase.auth.UserCredential) => {

  //     let findAccessToken = val.credential.toJSON()
  //     let accessTokenFromFire = findAccessToken['accessToken'];
  //     let userData = {
  //       "access_token": accessTokenFromFire,
  //       "type": 2
  //     }
  //     this.signUpService.signUpwithGoogle(userData).subscribe(data => {
  //       if (data["result"]["status"] == 200) {
  //         this.$gaService.event('host_sign_up', 'host_sign_up', data["data"].user.email)
  //         localStorage.setItem('token', data["data"]["token"]);
  //         localStorage.setItem('is_email_verified', data["data"]["user"]["is_email_verified"]);
  //         localStorage.setItem('userId', data["data"]["user"]["id"]);
  //         localStorage.setItem('is_phone_verified', data["data"]["user"]["is_phone_verified"]);
  //         localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]['user']));
  //         let user: object = data["data"]['user'];
  //         this.store.dispatch(AuthActions.LoginSuccess({ token: data['data']['token'], user }))
  //         //this.metaPixelService.onHostSignUpEvent(data["data"].user.email);
  //         const gtmTag = {
  //           event: 'gtmHostSignUp',
  //           data: {
  //             email: data['data']['user']['email'],
  //           }
  //         }
  //         this.gtmService.pushTag(gtmTag);
  //         this.route.navigate(['/','verification'])
  //       }
  //       else {
  //         this.toastr.error(data["result"]["message"], 'Error');
  //         //this.passingSignupData = false;
  //       }
  //     })
  //   })
  // }

  loginWithGoogle(): void {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();
  
    signInWithPopup(auth, provider).then((val) => {
      const credential = GoogleAuthProvider.credentialFromResult(val);
      const accessTokenFromFire = credential?.accessToken;
  
      const userData = {
        access_token: accessTokenFromFire,
        type: 2
      };
  
      this.signUpService.signUpwithGoogle(userData).subscribe((data: any) => {
        if (data.result.status === 200) {
          this.$gaService.event('host_sign_up', 'host_sign_up', data.data.user.email);
          localStorage.setItem('token', data.data.token);
          localStorage.setItem('is_email_verified', data.data.user.is_email_verified);
          localStorage.setItem('userId', data.data.user.id);
          localStorage.setItem('is_phone_verified', data.data.user.is_phone_verified);
          localStorage.setItem('CACHED_USER', JSON.stringify(data.data.user));
  
          const user = data.data.user;
          this.store.dispatch(AuthActions.LoginSuccess({ token: data.data.token, user }));
          // //this.metaPixelService.onHostSignUpEvent(data.data.user.email);
  
          const gtmTag = {
            event: 'gtmHostSignUp',
            data: { email: data.data.user.email }
          };
          this.gtmService.pushTag(gtmTag);
          this.route.navigate(['/','verification']);
        } else {
          this.toastr.error(data.result.message, 'Error');
        }
      });
    }).catch(err => {
      console.error("Google login error:", err);
      this.toastr.error("Google login failed", 'Error');
    });
  }
  socialUpdateValidation() {
    var hasError = false

    if (this.socialUpdateForm.controls.email.status == "INVALID") {
      this.socialUpdateForm.controls.email.markAsTouched()
      hasError = true;
    }
    return hasError;
  }
  updateSocialLoginProfile() {
    if (this.socialUpdateValidation() == false) {
      var facebokData = {
        "email": this.socialUpdateForm.value.email
      }
      this.signUpService.updateUserDataForFacebookSocialLogin(this.socialLoginToken, facebokData).subscribe(data => {
        if (data["result"]["status"] == 200) {
          this.toastr.success(data["result"]["message"], 'Success');
          $('#socialUpdateModal').modal('hide')
          localStorage.setItem('token', this.socialLoginToken);
          localStorage.setItem('is_email_verified', data["data"]["is_email_verified"]);
          localStorage.setItem('userId', data["data"]["id"]);
          localStorage.setItem('is_phone_verified', data["data"]["is_phone_verified"]);
          localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]));
          this.route.navigate(['/','verification'])
        }
        else {
          this.toastr.error(data["result"]["message"], 'Error');
        }

      })
    }
  }
}